(function () {
  'use strict';

  if (window.fiAklaInviteUsOverLoaded) return;
  window.fiAklaInviteUsOverLoaded = true;

  var fiAklaApntlySkin = "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:wght@400;500;600;700&display=swap');\n\n* {\n  --primary: #940002 !important;\n  --secondary: #fd5c02 !important;\n  --grey: #f1eadb !important;\n  --text-black: #111111 !important;\n  --text-light-black: #5a4b45 !important;\n  box-sizing: border-box;\n}\n\nbody.is-embed-true,\n.is-embed-true.fade-in {\n  margin: 0 !important;\n  color: #111111 !important;\n  background: transparent !important;\n}\n\n.is-embed-true .modal {\n  height: auto !important;\n  min-height: 0 !important;\n  align-items: flex-start !important;\n}\n\n.is-embed-true .modal-container {\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 24px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #f1eadb !important;\n  box-shadow: none !important;\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n.is-embed-true .close-icon {\n  display: none !important;\n}\n\n.is-embed-true .main-heading {\n  margin: 0 0 20px !important;\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 34px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.02em !important;\n  line-height: 1 !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .container {\n  gap: 20px !important;\n  justify-content: flex-start !important;\n}\n\n.is-embed-true .date-time-picker {\n  width: 100% !important;\n  max-width: none !important;\n}\n\n.is-embed-true .mobile-calendar-selector {\n  margin: 0 0 4px !important;\n}\n\n.is-embed-true label {\n  color: #940002 !important;\n  font-weight: 700 !important;\n}\n\n.is-embed-true .vs__dropdown-toggle {\n  min-height: 48px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vs__selected {\n  color: #111111 !important;\n  background: transparent !important;\n}\n\n.is-embed-true .vs__open-indicator,\n.is-embed-true .vs__clear {\n  fill: #940002 !important;\n}\n\n.is-embed-true .vs__dropdown-menu {\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vs__dropdown-option--highlight {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .vc-container {\n  width: 100% !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .vc-title {\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 25px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.02em !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .vc-highlight {\n  background: #fd5c02 !important;\n}\n\n.is-embed-true .vc-day-content:hover {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .timezone-container {\n  margin: 14px 0 18px !important;\n  color: #5a4b45 !important;\n}\n\n.is-embed-true .side-menu {\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.is-embed-true .select-time-slot {\n  margin: 0 0 10px !important;\n  color: #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 23px !important;\n  letter-spacing: 0.02em !important;\n  line-height: 1 !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .time-slots-container {\n  max-height: none !important;\n  gap: 8px !important;\n  overflow: visible !important;\n}\n\n.is-embed-true .time-slot-container {\n  width: 100% !important;\n}\n\n.is-embed-true .time-slot {\n  margin: 0 !important;\n  padding: 11px 14px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #940002 !important;\n  background: #fffdf7 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n}\n\n.is-embed-true .time-slot.selected,\n.is-embed-true .time-slot:hover {\n  color: #f1eadb !important;\n  background: #940002 !important;\n}\n\n.is-embed-true .time-slot.disabled,\n.is-embed-true .time-slot.disabled:hover {\n  color: #5a4b45 !important;\n  background: #f1eadb !important;\n  opacity: 0.38 !important;\n}\n\n.is-embed-true .btn-book-margin {\n  margin-top: 18px !important;\n}\n\n.is-embed-true .book-button-container .btn-book,\n.is-embed-true .btn-book-questions,\n.is-embed-true .btn-book-customer-details-questions {\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 50px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #f1eadb !important;\n  background: #fd5c02 !important;\n  box-shadow: 4px 4px 0 #940002 !important;\n  font-family: 'Bebas Neue', sans-serif !important;\n  font-size: 24px !important;\n  font-weight: 400 !important;\n  letter-spacing: 0.04em !important;\n  text-transform: uppercase !important;\n}\n\n.is-embed-true .book-button-container .btn-book[disabled],\n.is-embed-true .btn-book-questions[disabled],\n.is-embed-true .btn-book-customer-details-questions[disabled] {\n  color: #f1eadb !important;\n  background: #fd5c02 !important;\n  opacity: 0.38 !important;\n}\n\n.is-embed-true .time-slot-not-selected-text {\n  margin: 12px 0 0 !important;\n  color: #5a4b45 !important;\n  font-size: 12px !important;\n}\n\n.is-embed-true .answer-text,\n.is-embed-true .vue-tel-input.answer-text {\n  min-height: 46px !important;\n  border: 2px solid #940002 !important;\n  border-radius: 0 !important;\n  color: #111111 !important;\n  background: #fffdf7 !important;\n}\n\n.is-embed-true .free-booking-success-message-container {\n  border: 2px solid #940002 !important;\n  color: #940002 !important;\n  background: #fffdf7 !important;\n}\n\n@media only screen and (max-width: 480px) {\n  .is-embed-true .modal-container {\n    width: 100% !important;\n    padding: 16px !important;\n  }\n\n  .is-embed-true .main-heading {\n    font-size: 30px !important;\n  }\n\n  .is-embed-true .container {\n    gap: 16px !important;\n  }\n}\n/* Stage 3.4 button system */\n.is-embed-true .book-button-container .btn-book,.is-embed-true .btn-book-questions,.is-embed-true .btn-book-customer-details-questions { min-height:72px!important; padding:14px 40px!important; font-size:32px!important; line-height:1.12!important; letter-spacing:.05em!important; color:#940002!important; background:#fd5c02!important; border:2px solid #940002!important; border-radius:0!important; box-shadow:8px 8px 0 #940002!important; transition:transform .15s ease,box-shadow .15s ease!important; }\n.is-embed-true .time-slot {min-height:58px!important;background:#f1eadb!important;font-family:'Bebas Neue',sans-serif!important;font-size:26px!important;letter-spacing:.05em!important;box-shadow:none!important;}\n.is-embed-true .time-slot.selected {background:#940002!important;color:#f1eadb!important;}\n.is-embed-true .btn-book:focus-visible,.is-embed-true .time-slot:focus-visible {outline:3px solid #940002!important;outline-offset:4px!important;}\n@media(hover:hover){.is-embed-true .btn-book:not([disabled]):hover{transform:translate(4px,4px)!important;box-shadow:4px 4px 0 #940002!important;}}\n.is-embed-true .btn-book:not([disabled]):active{transform:translate(8px,8px)!important;box-shadow:none!important;}\n.is-embed-true .btn-book[disabled],.is-embed-true .btn-book-questions[disabled],.is-embed-true .btn-book-customer-details-questions[disabled]{box-shadow:none!important;transform:none!important;opacity:.5!important;color:#940002!important;}\n@media(max-width:749px){.is-embed-true .book-button-container .btn-book,.is-embed-true .btn-book-questions,.is-embed-true .btn-book-customer-details-questions{min-height:60px!important;font-size:27px!important;padding:12px 28px!important;box-shadow:6px 6px 0 #940002!important;}.is-embed-true .time-slot{min-height:54px!important;font-size:24px!important;}}\n@media(prefers-reduced-motion:reduce){.is-embed-true .btn-book{transition:none!important;}.is-embed-true .btn-book:hover,.is-embed-true .btn-book:active{transform:none!important;}}\n\n@media(max-width:749px){.is-embed-true .book-button-container .btn-book[disabled],.is-embed-true .btn-book-questions[disabled],.is-embed-true .btn-book-customer-details-questions[disabled]{box-shadow:none!important;transform:none!important;}}\n";

  function applyFiAklaApntlySkin() {
    var config = window.appointlyConfig;
    var booking = config && config.booking;
    if (!booking || typeof booking.bookingHtml !== 'string') return false;
    if (booking.bookingHtml.indexOf('data-fi-akla-apntly-skin') !== -1) return true;

    booking.bookingHtml = booking.bookingHtml.replace(
      '</head>',
      '<style data-fi-akla-apntly-skin>' + fiAklaApntlySkin + '</style></head>'
    );
    return true;
  }

  if (!applyFiAklaApntlySkin()) {
    var fiAklaSkinAttempts = 0;
    var fiAklaSkinTimer = window.setInterval(function () {
      fiAklaSkinAttempts += 1;
      if (applyFiAklaApntlySkin() || fiAklaSkinAttempts >= 240) {
        window.clearInterval(fiAklaSkinTimer);
      }
    }, 25);
  }

  function formatEgp(cents) {
    return 'LE ' + new Intl.NumberFormat('en-EG', {
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
  }

  var pendingBookingKey = 'fiAklaInviteUsOverPending';

  function protectScrollDuringAppntlyMount(root) {
    var calendarEmbed = root && root.querySelector('[data-iou-apntly-embed]');
    if (!calendarEmbed || calendarEmbed.dataset.iouScrollGuard === 'true') return;

    calendarEmbed.dataset.iouScrollGuard = 'true';
    var scrollingElement = document.scrollingElement;
    var pageWrapper = document.querySelector('.page-wrapper');
    var initialX = window.scrollX;
    var initialY = window.scrollY;
    var initialDocumentTop = scrollingElement ? scrollingElement.scrollTop : initialY;
    var initialWrapperTop = pageWrapper ? pageWrapper.scrollTop : 0;
    var active = true;
    var restoring = false;
    var restoreFrame = 0;
    var releaseTimer = 0;
    var observer = null;
    var burstTimers = [];
    var userEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var previousScrollBehavior = document.documentElement.style.scrollBehavior;
    var previousOverflowAnchor = document.documentElement.style.overflowAnchor;

    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.style.overflowAnchor = 'none';

    function restorePosition() {
      if (!active || restoring) return;
      restoring = true;
      if (scrollingElement) scrollingElement.scrollTop = initialDocumentTop;
      if (pageWrapper) pageWrapper.scrollTop = initialWrapperTop;
      window.scrollTo({ left: initialX, top: initialY, behavior: 'auto' });
      var focused = document.activeElement;
      if (focused && focused.id === 'apntly-booking-iframe' && typeof focused.blur === 'function') focused.blur();
      window.requestAnimationFrame(function () { restoring = false; });
    }

    function onScroll() {
      if (!active || restoring || restoreFrame) return;
      restoreFrame = window.requestAnimationFrame(function () {
        restoreFrame = 0;
        restorePosition();
      });
    }

    function release() {
      if (!active) return;
      active = false;
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('focusin', onFocusIn, true);
      if (scrollingElement) scrollingElement.removeEventListener('scroll', onScroll);
      if (pageWrapper) pageWrapper.removeEventListener('scroll', onScroll);
      userEvents.forEach(function (name) { window.removeEventListener(name, release); });
      if (observer) observer.disconnect();
      if (restoreFrame) window.cancelAnimationFrame(restoreFrame);
      burstTimers.forEach(function (timer) { window.clearTimeout(timer); });
      window.clearTimeout(releaseTimer);
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      document.documentElement.style.overflowAnchor = previousOverflowAnchor;
    }

    function onFocusIn(event) {
      if (!active) return;
      if (event.target && event.target.id === 'apntly-booking-iframe') restorePosition();
    }

    function holdThroughFrameMount(iframe) {
      if (!iframe || iframe.dataset.iouScrollProtected === 'true') return;
      iframe.dataset.iouScrollProtected = 'true';
      iframe.setAttribute('tabindex', '-1');
      iframe.addEventListener('load', restorePosition);
      [0, 50, 150, 350, 750, 1500, 3000, 5000].forEach(function (delay) {
        burstTimers.push(window.setTimeout(restorePosition, delay));
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('focusin', onFocusIn, true);
    if (scrollingElement) scrollingElement.addEventListener('scroll', onScroll, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
    userEvents.forEach(function (name) {
      window.addEventListener(name, release, { once: true, passive: true });
    });

    observer = new MutationObserver(function () {
      var iframe = document.getElementById('apntly-booking-iframe');
      if (iframe && calendarEmbed.contains(iframe)) holdThroughFrameMount(iframe);
      restorePosition();
    });
    observer.observe(calendarEmbed, { childList: true, subtree: true });
    holdThroughFrameMount(document.getElementById('apntly-booking-iframe'));
    releaseTimer = window.setTimeout(release, 30000);
  }

  function readPendingBooking() {
    try {
      return JSON.parse(window.sessionStorage.getItem(pendingBookingKey) || 'null');
    } catch (error) {
      return null;
    }
  }

  function clearPendingBooking() {
    document.documentElement.removeAttribute('data-iou-cart-handoff');
    try {
      window.sessionStorage.removeItem(pendingBookingKey);
    } catch (error) {
      return;
    }
  }

  function hideOperationalBookingProperties(source, keepBookingVisible) {
    var hidden = {};

    Object.keys(source || {}).forEach(function (key) {
      var value = source[key];
      if (value === null || typeof value === 'undefined' || value === '') return;

      if (key.charAt(0) === '_') {
        hidden[key] = value;
      } else if (keepBookingVisible && key === 'Booking') {
        hidden.Booking = value;
      } else {
        hidden['_Fi Akla ' + key] = value;
      }
    });

    return hidden;
  }

  async function hideExistingCartBookingDetails() {
    if (!window.location.pathname.match(/\/cart\/?$/)) return;
    if (window.fiAklaCartPropertyCleanupRunning) return;
    window.fiAklaCartPropertyCleanupRunning = true;
    var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';

    try {
      var response = await fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) return;
      var cart = await response.json();
      var line = (cart.items || []).find(function (item) {
        var properties = item.properties || {};
        return properties['_Fi Akla booking handoff'] && Object.keys(properties).some(function (key) {
          return key.charAt(0) !== '_' && key !== 'Booking';
        });
      });

      if (!line) return;
      var update = await fetch(shopRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: line.key,
          quantity: line.quantity,
          properties: hideOperationalBookingProperties(line.properties, true)
        })
      });
      if (update.ok) window.location.reload();
    } catch (error) {
      console.error('[Fi Akla] Could not hide operational booking details in the cart.', error);
    } finally {
      window.fiAklaCartPropertyCleanupRunning = false;
    }
  }

  async function recoverPendingBooking() {
    var pending = readPendingBooking();
    if (!pending || !pending.variantId || !window.location.pathname.match(/\/cart\/?$/)) {
      document.documentElement.removeAttribute('data-iou-cart-handoff');
      return;
    }
    if (window.fiAklaInviteRecoveryRunning) return;
    window.fiAklaInviteRecoveryRunning = true;
    var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';

    try {
      var cartResponse = await fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) throw new Error('Could not load the reserved booking.');
      var cart = await cartResponse.json();
      var completedLine = (cart.items || []).find(function (item) {
        return item.properties && item.properties['_Fi Akla booking handoff'] === pending.handoffId;
      });
      var temporaryLine = (cart.items || []).find(function (item) {
        var properties = item.properties || {};
        var isAppntly = String(properties._booking_by || '').toLowerCase().indexOf('appointly') !== -1;
        var sameTime = !pending.bookingTimestamp || String(properties._booking_start_timestamp || '') === pending.bookingTimestamp;
        return isAppntly && sameTime;
      });

      if (!temporaryLine && !completedLine) {
        window.fiAklaInviteRecoveryAttempts = Number(window.fiAklaInviteRecoveryAttempts || 0) + 1;
        if (window.fiAklaInviteRecoveryAttempts >= 20) {
          clearPendingBooking();
          document.documentElement.setAttribute('data-iou-handoff-error', 'true');
          return;
        }
        window.fiAklaInviteRecoveryRunning = false;
        window.setTimeout(recoverPendingBooking, 500);
        return;
      }

      document.documentElement.setAttribute('data-iou-cart-handoff', 'true');
      if (!completedLine) {
        var bookingGroup = pending.handoffId;
        var properties = hideOperationalBookingProperties(temporaryLine.properties || {}, true);
        Object.assign(properties, hideOperationalBookingProperties(pending.properties || {}, false));
        properties['_Booking group'] = bookingGroup;
        properties['_Fi Akla booking handoff'] = pending.handoffId;
        var items = [{ id: Number(pending.variantId), quantity: 1, properties: properties }];

        if (pending.extraMains) {
          items.push({ id: Number(pending.mainAddonId), quantity: Number(pending.covers) * Number(pending.extraMains), properties: {
            '_Booking type': 'Invite Us Over add-on', '_Booking group': bookingGroup,
            '_Service': pending.serviceTitle || '', 'Add-on': 'Extra main · LE 250 per person'
          }});
        }
        if (pending.extraSides) {
          items.push({ id: Number(pending.sideAddonId), quantity: Number(pending.covers) * Number(pending.extraSides), properties: {
            '_Booking type': 'Invite Us Over add-on', '_Booking group': bookingGroup,
            '_Service': pending.serviceTitle || '', 'Add-on': 'Extra side · LE 120 per person'
          }});
        }

        var addResponse = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addResponse.ok) throw new Error('Could not add the priced Invite Us Over package.');
      }

      if (temporaryLine) {
        var removeResponse = await fetch(shopRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: temporaryLine.key, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('Could not remove the temporary booking item.');
      }

      try { if (pending.draftStorageKey) window.sessionStorage.removeItem(pending.draftStorageKey); } catch (error) {}
      clearPendingBooking();
      window.location.replace(shopRoot + 'cart');
    } catch (error) {
      window.fiAklaInviteRecoveryRunning = false;
      console.error('[Fi Akla] Invite Us Over cart handoff failed.', error);
      document.documentElement.removeAttribute('data-iou-cart-handoff');
      document.documentElement.setAttribute('data-iou-handoff-error', 'true');
    }
  }

  function init(root) {
    if (!root || root.dataset.iouReady === 'true' || !window.FiAklaCustomerDetails) return;
    var form = root.querySelector('form');
    var variantData = root.querySelector('[data-iou-variants]');
    if (!form || !variantData) return;

    var variants = [];
    try {
      variants = JSON.parse(variantData.textContent || '[]');
    } catch (error) {
      console.error('[Fi Akla] Could not read Invite Us Over variants.', error);
      return;
    }

    root.dataset.iouReady = 'true';
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-iou-option]'));
    var variantId = root.querySelector('[data-iou-variant-id]');
    var price = root.querySelector('[data-iou-price]');
    var packageProperty = root.querySelector('[data-iou-package-property]');
    var shoppingProperty = root.querySelector('[data-iou-shopping-property]');
    var noticeProperty = root.querySelector('[data-iou-notice-property]');
    var groceryTermsProperty = root.querySelector('[data-iou-grocery-terms-property]');
    var extraMains = root.querySelector('[data-iou-extra-mains]');
    var extraSides = root.querySelector('[data-iou-extra-sides]');
    var coversOutput = root.querySelector('[data-iou-covers]');
    var addonTotalOutput = root.querySelector('[data-iou-addon-total]');
    var addonProperty = root.querySelector('[data-iou-addon-property]');
    var submit = root.querySelector('[data-iou-submit]');
    var formError = root.querySelector('[data-iou-form-error]');
    var applianceInputs = Array.prototype.slice.call(root.querySelectorAll('[data-iou-appliance]'));
    var applianceOther = root.querySelector('[data-iou-appliance-other]');
    var applianceDetailsWrap = root.querySelector('[data-iou-appliance-details]');
    var applianceDetails = applianceDetailsWrap && applianceDetailsWrap.querySelector('textarea');
    var applianceValue = root.querySelector('[data-iou-appliances-value]');
    var applianceError = root.querySelector('[data-iou-appliances-error]');
    var appointmentDate = root.querySelector('[data-iou-appointment-date]');
    var arrivalTime = root.querySelector('[data-iou-arrival-time]');
    var calendarSummary = root.querySelector('[data-iou-calendar-summary]');
    var calendarEmbed = root.querySelector('[data-iou-apntly-embed]');
    var calendarLoading = root.querySelector('[data-iou-calendar-loading]');
    var phoneInput = root.querySelector('[data-iou-phone]');
    var mapsPinInput = root.querySelector('[data-iou-maps-pin]');
    var customerProfileData = root.querySelector('[data-iou-customer-profile]');
    var useProfileAddress = root.querySelector('[data-iou-use-profile-address]');
    var customerDetails = window.FiAklaCustomerDetails;
    var lastConfirmedBookingKey = '';
    var selectedBookingTimestamp = '';
    var isSubmitting = false;

    function readSavedProfile() {
      try {
        return JSON.parse(window.localStorage.getItem('fiAklaInviteUsOverProfile') || 'null');
      } catch (error) {
        return null;
      }
    }

    function applySavedProfile() {
      var profile = null;
      try {
        profile = customerProfileData ? JSON.parse(customerProfileData.textContent || 'null') : null;
      } catch (error) {
        profile = null;
      }

      function fillProperty(propertyName, value) {
        var field = form.elements.namedItem('properties[' + propertyName + ']');
        if (field && !String(field.value || '').trim() && value) field.value = value;
      }

      if (profile) {
        fillProperty('WhatsApp number', profile.phone);
        fillProperty('Area', profile.area);
        fillProperty('Full service address', profile.service_address);
        fillProperty('Google Maps pin', profile.maps_pin);
        fillProperty('Building or villa number', profile.building);
        fillProperty('Floor', profile.floor);
        fillProperty('Access or parking notes', profile.access_notes);
        fillProperty('Other appliance details', profile.appliance_details);

        var mealRequestsField = form.elements.namedItem('properties[Meal requests]');
        if (mealRequestsField && !String(mealRequestsField.value || '').trim() && profile.cuisine_preference) {
          mealRequestsField.value = profile.cuisine_preference;
        }

        var anythingToKnowField = form.elements.namedItem('properties[Anything we should know]');
        if (profile.has_allergy_profile && anythingToKnowField && !String(anythingToKnowField.value || '').trim()) {
          var savedAllergyDetails = [];
          if ((profile.allergies || []).length) savedAllergyDetails.push((profile.allergies || []).join(', '));
          if (String(profile.allergy_details || '').trim()) savedAllergyDetails.push(String(profile.allergy_details).trim());
          anythingToKnowField.value = savedAllergyDetails.join(' — ');
        }

        applianceInputs.forEach(function (input) {
          if ((profile.appliances || []).indexOf(input.value) !== -1) input.checked = true;
        });
      }

      var saved = readSavedProfile();
      if (saved) {
        Object.keys(saved.fields || {}).forEach(function (propertyName) {
          fillProperty(propertyName, saved.fields[propertyName]);
        });
        applianceInputs.forEach(function (input) {
          if ((saved.appliances || []).indexOf(input.value) !== -1) input.checked = true;
        });
      }
    }

    var manualAddressValues = null;

    function normaliseAddressValue(value) {
      return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    function setAddressFieldValue(field, value) {
      if (!field || value === undefined || value === null || String(value).trim() === '') return false;
      if (field.tagName === 'SELECT') {
        var wanted = normaliseAddressValue(value);
        var matchingOption = Array.prototype.find.call(field.options, function (option) {
          return normaliseAddressValue(option.value) === wanted || normaliseAddressValue(option.textContent) === wanted;
        });
        if (!matchingOption) return false;
        field.value = matchingOption.value;
      } else {
        field.value = value;
      }
      field.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function setProfileFieldLock(field, locked) {
      if (!field) return;
      if (locked) {
        field.setAttribute('data-iou-profile-locked', '');
        field.setAttribute('aria-readonly', 'true');
        if (field.tagName === 'SELECT') {
          field.dataset.iouLockedValue = field.value;
          field.tabIndex = -1;
        } else {
          field.readOnly = true;
        }
      } else {
        field.removeAttribute('data-iou-profile-locked');
        field.removeAttribute('aria-readonly');
        if (field.tagName === 'SELECT') {
          delete field.dataset.iouLockedValue;
          field.removeAttribute('tabindex');
        } else {
          field.readOnly = false;
        }
      }
    }

    function applyProfileAddress() {
      if (!useProfileAddress || !customerProfileData) return;
      var profile = null;
      try {
        profile = JSON.parse(customerProfileData.textContent || 'null');
      } catch (error) {
        profile = null;
      }
      if (!profile || !profile.profile_address_available || !profile.profile_address) return;

      var locationNames = [
        'Area',
        'Building or villa number',
        'Full service address',
        'Floor',
        'Access or parking notes',
        'Google Maps pin'
      ];

      if (!useProfileAddress.checked) {
        locationNames.forEach(function (propertyName) {
          var field = form.elements.namedItem('properties[' + propertyName + ']');
          setProfileFieldLock(field, false);
          if (field && manualAddressValues && Object.prototype.hasOwnProperty.call(manualAddressValues, propertyName)) {
            field.value = manualAddressValues[propertyName];
          }
        });
        manualAddressValues = null;
        syncReadyState();
        return;
      }

      manualAddressValues = {};
      locationNames.forEach(function (propertyName) {
        var field = form.elements.namedItem('properties[' + propertyName + ']');
        if (field) manualAddressValues[propertyName] = field.value;
      });

      var address = profile.profile_address;
      var serviceAddress = address.service_address || profile.service_address || '';
      var values = {
        'Area': profile.area || address.area,
        'Building or villa number': profile.building || address.building || serviceAddress,
        'Full service address': profile.service_address || address.service_address,
        'Floor': profile.floor,
        'Access or parking notes': profile.access_notes,
        'Google Maps pin': profile.maps_pin,
        'WhatsApp number': profile.phone || address.phone
      };

      Object.keys(values).forEach(function (propertyName) {
        var field = form.elements.namedItem('properties[' + propertyName + ']');
        var filled = setAddressFieldValue(field, values[propertyName]);
        if (locationNames.indexOf(propertyName) !== -1) setProfileFieldLock(field, filled);
      });
      syncReadyState();
    }

    function saveReusableProfile() {
      var reusableNames = [
        'Other appliance details', 'Area', 'Building or villa number',
        'Full service address', 'Floor', 'Access or parking notes', 'Google Maps pin', 'WhatsApp number'
      ];
      var fields = {};
      reusableNames.forEach(function (propertyName) {
        var field = form.elements.namedItem('properties[' + propertyName + ']');
        if (field && String(field.value || '').trim()) fields[propertyName] = String(field.value).trim();
      });
      try {
        window.localStorage.setItem('fiAklaInviteUsOverProfile', JSON.stringify({
          fields: fields,
          appliances: applianceInputs.filter(function (input) { return input.checked; }).map(function (input) { return input.value; })
        }));
      } catch (error) {
        return;
      }
    }

    var selectionStorageKey = 'fiAklaChefSelection:' + root.dataset.iouServiceHandle;
    var draftStorageKey = 'fiAklaChefDraft:' + root.dataset.iouServiceHandle;
    function draftFields() {
      return Array.from(form.elements).filter(function (field) {
        return /^(INPUT|TEXTAREA|SELECT)$/.test(field.tagName) && field.type !== 'hidden' &&
          /^properties\[/.test(field.name || '') && field !== extraMains && field !== extraSides;
      });
    }
    function saveDraft() {
      var fields = {};
      draftFields().forEach(function (field) { fields[field.name] = field.type === 'checkbox' ? field.checked : field.value; });
      try { sessionStorage.setItem(draftStorageKey, JSON.stringify({at:Date.now(), fields:fields, appliances:applianceInputs.filter(function (input) { return input.checked; }).map(function (input) { return input.value; })})); } catch (error) {}
    }
    function restoreDraft() {
      try {
        var draft = JSON.parse(sessionStorage.getItem(draftStorageKey) || 'null');
        if (!draft || Date.now() - draft.at > 3600000) { sessionStorage.removeItem(draftStorageKey); return; }
        draftFields().forEach(function (field) {
          if (!Object.prototype.hasOwnProperty.call(draft.fields || {}, field.name)) return;
          if (field.type === 'checkbox') field.checked = !!draft.fields[field.name];
          else if (field.tagName !== 'SELECT' || Array.from(field.options).some(function (option) { return option.value === draft.fields[field.name]; })) field.value = draft.fields[field.name];
        });
        applianceInputs.forEach(function (input) { input.checked = (draft.appliances || []).indexOf(input.value) !== -1; });
      } catch (error) {}
    }
    var clearDraftButton = root.querySelector('[data-iou-clear-draft]');
    if (clearDraftButton) clearDraftButton.addEventListener('click', function () {
      draftFields().forEach(function (field) {
        if (field.type === 'checkbox') field.checked = false;
        else field.value = '';
      });
      applianceInputs.forEach(function (input) { input.checked = false; });
      try { sessionStorage.removeItem(draftStorageKey); } catch (error) {}
      clearPendingBooking();
      syncAppliances(false);
      syncReadyState();
    });
    form.addEventListener('input', saveDraft);
    form.addEventListener('change', saveDraft);

    function rememberSelection(variant) {
      try {
        window.sessionStorage.setItem(selectionStorageKey, JSON.stringify({
          variantId: variant.id,
          mains: Number(extraMains && extraMains.value || 0),
          sides: Number(extraSides && extraSides.value || 0),
          savedAt: Date.now()
        }));
      } catch (error) {}
    }
    function restoreSelection() {
      if (new URL(window.location.href).searchParams.has('variant')) return;
      try {
        var saved = JSON.parse(window.sessionStorage.getItem(selectionStorageKey) || 'null');
        if (!saved || Date.now() - saved.savedAt > 3600000) return;
        var variant = variants.find(function (entry) { return String(entry.id) === String(saved.variantId); });
        if (!variant) return;
        optionSelects.forEach(function (select, index) {
          if (Array.from(select.options).some(function (option) { return option.value === variant.options[index]; })) select.value = variant.options[index];
        });
        [[extraMains, saved.mains], [extraSides, saved.sides]].forEach(function (entry) {
          if (entry[0] && Array.from(entry[0].options).some(function (option) { return option.value === String(entry[1]); })) entry[0].value = String(entry[1]);
        });
      } catch (error) {}
    }

    function selectedVariant() {
      var selected = optionSelects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selected[index];
        });
      });
    }

    function selectedCovers() {
      if (root.dataset.iouServiceHandle === 'invite-us-over-fridge-fill') return 4;

      var guestSelect = optionSelects.find(function (select) {
        return /guest|people/i.test(select.dataset.optionName || '');
      }) || optionSelects.find(function (select) {
        return (select.dataset.optionName || '').toLowerCase() !== 'shopping method';
      });
      var match = guestSelect && String(guestSelect.value || '').match(/\d+/);
      return match ? Number(match[0]) : 0;
    }

    function selectedAddonCounts() {
      return {
        mains: Number(extraMains && extraMains.value || 0),
        sides: Number(extraSides && extraSides.value || 0)
      };
    }

    function addonTotalCents() {
      var covers = selectedCovers();
      var counts = selectedAddonCounts();
      return covers * ((counts.mains * 25000) + (counts.sides * 12000));
    }

    function syncAddonSummary() {
      var covers = selectedCovers();
      var total = formatEgp(addonTotalCents());
      if (coversOutput) coversOutput.textContent = String(covers);
      if (addonTotalOutput) addonTotalOutput.textContent = total;
      if (addonProperty) addonProperty.value = total;
    }

    function syncVariant() {
      var variant = selectedVariant();
      optionSelects.forEach(function (select) {
        var optionName = (select.dataset.optionName || '').toLowerCase();
        if (optionName === 'shopping method' && shoppingProperty) shoppingProperty.value = select.value;
        if (optionName !== 'shopping method' && packageProperty) packageProperty.value = select.value;
      });
      var fiAklaSources = !!(shoppingProperty && /fi akla|bring|source|shopping for me/i.test(shoppingProperty.value));
      if (noticeProperty) noticeProperty.value = fiAklaSources ? '48 hours' : '24 hours';
      if (groceryTermsProperty) {
        groceryTermsProperty.value = fiAklaSources
          ? 'Estimated groceries plus 10% sourcing fee paid in advance; reconciled against receipts'
          : 'Customer purchases groceries; Fi Akla provides the shopping list';
      }
      if (!variant) {
        variantId.value = '';
        price.textContent = root.dataset.iouUnavailable || 'Unavailable';
        syncReadyState();
        return;
      }

      variantId.value = variant.id;
      rememberSelection(variant);
      syncAddonSummary();
      price.textContent = formatEgp(Number(variant.price || 0) + addonTotalCents());
      syncReadyState();
    }

    function syncAppliances(showError) {
      var selected = applianceInputs.filter(function (input) { return input.checked; });
      var needsDetails = !!(applianceOther && applianceOther.checked);
      applianceValue.value = selected.map(function (input) { return input.value; }).join(', ');
      if (applianceDetailsWrap) applianceDetailsWrap.toggleAttribute('data-iou-hidden', !needsDetails);
      if (applianceDetails) {
        applianceDetails.disabled = !needsDetails;
        applianceDetails.required = needsDetails;
        if (!needsDetails) applianceDetails.value = '';
      }
      if (applianceError) {
        applianceError.toggleAttribute('data-iou-hidden', !(showError && selected.length === 0));
      }
      syncReadyState();
      return selected.length > 0;
    }

    function calendarReady() {
      return !!(appointmentDate && appointmentDate.value && arrivalTime && arrivalTime.value);
    }

    function bookingDetailsReady() {
      return !!(variantId && variantId.value && form.checkValidity()
        && applianceInputs.some(function (input) { return input.checked; })
        && (!applianceDetails || applianceDetails.disabled || applianceDetails.value.trim())
        && phoneInput && customerDetails && customerDetails.normalizePhone(phoneInput.value)
        && (!mapsPinInput || !mapsPinInput.value.trim() || customerDetails.isGoogleMapsPin(mapsPinInput.value)));
    }

    function syncReadyState() {
      var detailsReady = bookingDetailsReady();
      var calendar = root.querySelector('[data-iou-calendar]');
      var gate = root.querySelector('[data-iou-calendar-gate]');
      if (calendar) {
        calendar.inert = !detailsReady;
        calendar.hidden = !detailsReady;
      }
      if (gate) gate.hidden = detailsReady;
      var hasVariant = !!(variantId && variantId.value);
      var hasAppliance = applianceInputs.some(function (input) { return input.checked; });
      var applianceDetailsComplete = !applianceDetails || applianceDetails.disabled || !!applianceDetails.value.trim();
      var phoneComplete = !!(phoneInput && customerDetails && customerDetails.normalizePhone(phoneInput.value));
      var pinComplete = !mapsPinInput || !mapsPinInput.value.trim() || !!(customerDetails && customerDetails.isGoogleMapsPin(mapsPinInput.value));
      var ready = hasVariant && calendarReady() && hasAppliance && applianceDetailsComplete && phoneComplete && pinComplete;
      if (submit) submit.disabled = !ready || isSubmitting;
      if (formError && ready) formError.setAttribute('data-iou-hidden', '');
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', syncVariant);
    });
    if (extraMains) extraMains.addEventListener('change', syncVariant);
    if (extraSides) extraSides.addEventListener('change', syncVariant);
    applianceInputs.forEach(function (input) {
      input.addEventListener('change', function () { syncAppliances(false); });
    });
    if (applianceDetails) applianceDetails.addEventListener('input', syncReadyState);
    if (phoneInput) phoneInput.addEventListener('input', syncReadyState);
    if (mapsPinInput) mapsPinInput.addEventListener('input', syncReadyState);

    function syncApntlyCalendar() {
      var iframe = document.getElementById('apntly-booking-iframe');
      if (iframe && calendarEmbed && calendarEmbed.contains(iframe) && calendarLoading) {
        calendarLoading.setAttribute('data-iou-hidden', '');
      }

      var client = window.appointlyClient;
      var bookingData = client && client.apntlyBookingModalData;
      var iframeButton = appntlyBookingButton();
      if (iframeButton) iframeButton.textContent = root.dataset.iouReserveButton || 'Reserve a time';
      if (iframeButton && iframeButton.dataset.fiAklaHandoffReady !== 'true') {
        iframeButton.dataset.fiAklaHandoffReady = 'true';
        iframeButton.addEventListener('click', function (event) {
          var appliancesComplete = syncAppliances(true);
          var normalizedPhone = customerDetails && phoneInput ? customerDetails.normalizePhone(phoneInput.value) : '';
          var validPin = !mapsPinInput || !mapsPinInput.value.trim() || (customerDetails && customerDetails.isGoogleMapsPin(mapsPinInput.value));
          if (normalizedPhone && phoneInput) phoneInput.value = normalizedPhone;

          if (!variantId.value || !normalizedPhone || !validPin || !appliancesComplete || !form.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (formError) {
              formError.textContent = !normalizedPhone
                ? (root.dataset.iouPhoneError || 'Enter a valid Egyptian mobile number.')
                : (!validPin ? (root.dataset.iouPinError || 'Paste a valid Google Maps link.') : (root.dataset.iouFormError || 'Please complete the required booking details.'));
              formError.removeAttribute('data-iou-hidden');
            }
            form.reportValidity();
            return;
          }

          var slot = null;
          try {
            slot = window.appointlyClient && window.appointlyClient.getSelectedSlot();
          } catch (error) {
            slot = null;
          }
          var counts = selectedAddonCounts();
          saveReusableProfile();
          var pending = {
            handoffId: 'iou-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8),
            variantId: Number(variantId.value),
            properties: bookingProperties(),
            covers: selectedCovers(),
            extraMains: counts.mains,
            extraSides: counts.sides,
            mainAddonId: Number(root.dataset.iouExtraMainVariant || 0),
            sideAddonId: Number(root.dataset.iouExtraSideVariant || 0),
            draftStorageKey: draftStorageKey,
        serviceTitle: root.dataset.iouServiceTitle || '',
            bookingTimestamp: String(slot && slot.bookingTimestamp || '')
          };
          try {
            window.sessionStorage.setItem(pendingBookingKey, JSON.stringify(pending));
          } catch (error) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (formError) {
              formError.textContent = root.dataset.iouAddError || 'Could not prepare this booking. Please try again.';
              formError.removeAttribute('data-iou-hidden');
            }
          }
        }, true);
      }
      if (!client || !bookingData || Number(bookingData.screen) !== 4) return;
      if (iframeButton) {
        iframeButton.textContent = root.dataset.iouReservedButton || 'Submitted';
        iframeButton.disabled = true;
      }
      var successMessage = appntlySuccessMessage();
      if (successMessage) successMessage.textContent = root.dataset.iouReservedButton || 'Submitted';

      var slot = null;
      try {
        slot = client.getSelectedSlot();
      } catch (error) {
        slot = null;
      }
      if (!slot) return;

      var date = '';
      try {
        date = client.getDateFromTimestampStartBrowserFormatted(slot);
      } catch (error) {
        date = '';
      }
      if (!date && slot.bookingTimestamp) {
        try {
          date = new Intl.DateTimeFormat(document.documentElement.lang || 'en-EG', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          }).format(new Date(Number(slot.bookingTimestamp)));
        } catch (error) {
          date = '';
        }
      }

      var time = [slot.start, slot.end].filter(Boolean).join(' - ');
      var bookingKey = [
        slot.bookingTimestamp,
        slot.start,
        slot.end,
        slot.serviceVariant && slot.serviceVariant.uniqueId
      ].join('|');

      if (!date || !time || bookingKey === lastConfirmedBookingKey) return;
      lastConfirmedBookingKey = bookingKey;
      selectedBookingTimestamp = String(slot.bookingTimestamp || '');
      root.dispatchEvent(new CustomEvent('iou:calendar-selected', {
        detail: { date: date, time: time },
        bubbles: true
      }));
    }

    root.addEventListener('iou:calendar-selected', function (event) {
      var detail = event.detail || {};
      appointmentDate.value = detail.date || '';
      arrivalTime.value = detail.time || '';
      if (calendarSummary) {
        calendarSummary.textContent = calendarReady()
          ? (root.dataset.iouCalendarReserved || 'Chef time reserved:') + ' ' + appointmentDate.value + ' · ' + arrivalTime.value
          : (root.dataset.iouCalendarEmpty || 'No appointment reserved yet.');
      }
      syncReadyState();
    });

    if (calendarEmbed) {
      calendarEmbed.addEventListener('pointerenter', stagePendingBooking);
      calendarEmbed.addEventListener('touchstart', stagePendingBooking, { passive: true });
      syncApntlyCalendar();
      window.setInterval(syncApntlyCalendar, 500);
      window.setTimeout(function () {
        if (!calendarEmbed.querySelector('iframe') && calendarLoading) {
          calendarLoading.textContent = root.dataset.iouCalendarUnavailable;
          calendarLoading.removeAttribute('data-iou-hidden');
        }
      }, 15000);
    }

    function bookingProperties() {
      var properties = {};
      new FormData(form).forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value).trim();
      });
      return properties;
    }

    function stagePendingBooking() {
      syncReadyState();
      if (!bookingDetailsReady()) { clearPendingBooking(); return; }
      var counts = selectedAddonCounts();
      var existing = readPendingBooking();
      var pending = {
        handoffId: existing && existing.handoffId || ('iou-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)),
        variantId: Number(variantId.value),
        properties: bookingProperties(),
        covers: selectedCovers(),
        extraMains: counts.mains,
        extraSides: counts.sides,
        mainAddonId: Number(root.dataset.iouExtraMainVariant || 0),
        sideAddonId: Number(root.dataset.iouExtraSideVariant || 0),
        draftStorageKey: draftStorageKey,
        serviceTitle: root.dataset.iouServiceTitle || '',
        bookingTimestamp: existing && existing.bookingTimestamp || ''
      };
      try {
        window.sessionStorage.setItem(pendingBookingKey, JSON.stringify(pending));
      } catch (error) {
        return;
      }
    }

    var pendingSaveTimer = null;
    function schedulePendingSave() {
      window.clearTimeout(pendingSaveTimer);
      pendingSaveTimer = window.setTimeout(stagePendingBooking, 100);
    }
    form.addEventListener('input', syncReadyState);
    form.addEventListener('input', schedulePendingSave);
    form.addEventListener('change', stagePendingBooking);
    window.addEventListener('blur', function () {
      var iframe = document.getElementById('apntly-booking-iframe');
      if (iframe && document.activeElement === iframe) stagePendingBooking();
    });

    function addonProperties(group, label) {
      return {
        '_Booking type': 'Invite Us Over add-on',
        '_Booking group': group,
        '_Service': root.dataset.iouServiceTitle || '',
        'Add-on': label,
        'Appointment date': appointmentDate.value,
        'Arrival time': arrivalTime.value
      };
    }

    function appntlyBookingButton() {
      var iframe = document.getElementById('apntly-booking-iframe');
      try {
        return iframe && iframe.contentDocument && iframe.contentDocument.querySelector(
          '.btn-book, .btn-book-questions, .btn-book-customer-details-questions'
        );
      } catch (error) {
        return null;
      }
    }

    function appntlySuccessMessage() {
      var iframe = document.getElementById('apntly-booking-iframe');
      try {
        return iframe && iframe.contentDocument && iframe.contentDocument.querySelector('.free-booking-success-message-container');
      } catch (error) {
        return null;
      }
    }

    async function cartState(shopRoot) {
      var response = await fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error(root.dataset.iouAddError || 'Could not load the cart.');
      return response.json();
    }

    function appntlyLine(cart) {
      return (cart.items || []).find(function (item) {
        var properties = item.properties || {};
        return String(properties._booking_by || '').toLowerCase().indexOf('appointly') !== -1 &&
          String(properties._booking_start_timestamp || '') === selectedBookingTimestamp;
      });
    }

    form.addEventListener('submit', function (event) {
      if (!event.submitter) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var appliancesComplete = syncAppliances(true);
      var normalizedPhone = customerDetails && phoneInput ? customerDetails.normalizePhone(phoneInput.value) : '';
      var validPin = !mapsPinInput || !mapsPinInput.value.trim() || (customerDetails && customerDetails.isGoogleMapsPin(mapsPinInput.value));
      if (normalizedPhone && phoneInput) phoneInput.value = normalizedPhone;
      if (!normalizedPhone || !validPin) {
        if (formError) {
          formError.textContent = !normalizedPhone
            ? (root.dataset.iouPhoneError || 'Enter a valid Egyptian mobile number.')
            : (root.dataset.iouPinError || 'Paste a valid Google Maps link.');
          formError.removeAttribute('data-iou-hidden');
        }
        (normalizedPhone && mapsPinInput && mapsPinInput.value.trim() ? mapsPinInput : phoneInput).focus();
        return;
      }
      if (!calendarReady() || !appliancesComplete || !form.checkValidity()) {
        if (formError) formError.removeAttribute('data-iou-hidden');
        form.reportValidity();
        return;
      }

      var counts = selectedAddonCounts();
      var covers = selectedCovers();
      var mainAddonId = Number(root.dataset.iouExtraMainVariant || 0);
      var sideAddonId = Number(root.dataset.iouExtraSideVariant || 0);
      if ((counts.mains || counts.sides) && (!covers || (counts.mains && !mainAddonId) || (counts.sides && !sideAddonId))) {
        if (formError) {
          formError.textContent = root.dataset.iouAddonError || 'The add-on price could not be configured. Please refresh and try again.';
          formError.removeAttribute('data-iou-hidden');
        }
        return;
      }

      document.dispatchEvent(new CustomEvent('fi-akla:invite-booking-started', {
        detail: {
          source: 'invite_us_over',
          service_handle: root.dataset.iouServiceHandle || '',
          variant_id: variantId.value,
          covers: covers,
          extra_mains: counts.mains,
          extra_sides: counts.sides
        }
      }));

      isSubmitting = true;
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = root.dataset.iouAdding || 'Adding…';
      }
      if (formError) formError.setAttribute('data-iou-hidden', '');

      var shopRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      try {
        var temporaryBookingLine = appntlyLine(await cartState(shopRoot));
        if (!temporaryBookingLine) throw new Error(root.dataset.iouReservationError || 'Reserve a time before continuing.');
        var bookingGroup = 'iou-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var properties = Object.assign({}, temporaryBookingLine.properties || {}, bookingProperties());
        properties['_Booking group'] = bookingGroup;
        var items = [{ id: Number(variantId.value), quantity: 1, properties: properties }];
        if (counts.mains) items.push({ id: mainAddonId, quantity: covers * counts.mains, properties: addonProperties(bookingGroup, 'Extra main · LE 250 per person') });
        if (counts.sides) items.push({ id: sideAddonId, quantity: covers * counts.sides, properties: addonProperties(bookingGroup, 'Extra side · LE 120 per person') });
        var response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var result = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(result.description || result.message || root.dataset.iouAddError || 'Could not add this booking.');
        var removeResponse = await fetch(shopRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: temporaryBookingLine.key, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error(root.dataset.iouCleanupError || 'Your time is reserved, but the cart needs review before checkout.');
        document.dispatchEvent(new CustomEvent('fi-akla:invite-booking-added', {
          detail: {
            source: 'invite_us_over',
            service_handle: root.dataset.iouServiceHandle || '',
            variant_id: variantId.value,
            covers: covers
          }
        }));
        try { sessionStorage.removeItem(draftStorageKey); } catch (error) {}
        window.location.assign(shopRoot + 'cart');
      } catch (error) {
        isSubmitting = false;
        if (submit) {
          submit.removeAttribute('aria-busy');
          submit.textContent = root.dataset.iouAddButton || 'Add to booking';
        }
        syncReadyState();
        if (formError) {
          formError.textContent = error.message || root.dataset.iouAddError || 'Could not add this booking. Please try again.';
          formError.removeAttribute('data-iou-hidden');
        }
      }
    });

    if (useProfileAddress) {
      useProfileAddress.addEventListener('change', applyProfileAddress);
      form.addEventListener('change', function (event) {
        var field = event.target;
        if (field && field.tagName === 'SELECT' && field.hasAttribute('data-iou-profile-locked')) {
          field.value = field.dataset.iouLockedValue || '';
        }
      });
    }
    applySavedProfile();
    restoreDraft();
    restoreSelection();
    syncVariant();
    syncAppliances(false);
    stagePendingBooking();
  }

  function initAll() {
    document.querySelectorAll('[data-iou-product]').forEach(function (root) {
      protectScrollDuringAppntlyMount(root);
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      recoverPendingBooking();
      hideExistingCartBookingDetails();
    }, { once: true });
  } else {
    initAll();
    recoverPendingBooking();
    hideExistingCartBookingDetails();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-iou-product]');
    if (root) {
      protectScrollDuringAppntlyMount(root);
      init(root);
    }
    recoverPendingBooking();
    hideExistingCartBookingDetails();
  });

  window.addEventListener('pageshow', function () {
    recoverPendingBooking();
    hideExistingCartBookingDetails();
  });
  window.setInterval(function () { initAll(); recoverPendingBooking(); }, 500);
})();



